import { Tooltip } from '@gto/ui/tooltip'

import type { CategoryOption } from '@/pages/rewards/constants'
import { CategoryColorMapping } from '@/pages/rewards/constants'

export type CategoryColorBadgeProps = {
  category?: CategoryOption
  color?: string
}

export const CategoryColorBadge = ({ category, color }: CategoryColorBadgeProps) => {
  const backgroundColor = category === undefined ? color : CategoryColorMapping[category]

  return (
    <Tooltip content={category}>
      <div
        // `shrink-0`: this sits beside a truncating cell label, and flex would otherwise take
        // its share of the deficit — measured squashing the 10px dot to 6px.
        className="size-[10px] shrink-0 rounded-full border-2 border-text-secondary/50 bg-text-secondary"
        style={
          backgroundColor !== undefined && backgroundColor.length > 0
            ? { backgroundColor }
            : undefined
        }
      />
    </Tooltip>
  )
}
